<script>
    import { location } from "svelte-spa-router";
    console.log($location);
    export let items;
</script>

<ul class="navtabs">
    {#each items as item}
        <li class="nav-item">
            <a
                class="nav-link {$location === `${item.path}`
                    ? 'active shadow'
                    : null}"
                href={`#${item.path}`}>{item.label}</a
            >
        </li>
    {/each}
</ul>

<style>
    .navtabs {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        list-style: none;
        margin-bottom: 0px;
    }
    .nav-link {
        color: #242424;
        border-radius: 7px 7px 0px 0px;
        padding: 5px 15px;
        margin-right: 10px;
        background: #f1f1f1;
    }
    .nav-item a.active {
        background: #ffffff;
        color: #242424;
    }
    .nav-item a.active {
        color: 2px solid rgb(0 123 255 / 58%) !important;
    }
    .nav ul {
    }
    .nav li {
    }
</style>
